import React, { useState, useMemo } from 'react';
import styled from 'styled-components';
import { LoadingState } from '../../../components/stats_components/LoadingState';
import MainContainer from '../../../components/ui_components/MainContainer';
import colors from '../../../styles/colors';
import SingleCardStatWrestlerMobile from '../../../components/MobileComponents/Stats/SingleCardStatWrestlerMobile';
import { useNavigate } from 'react-router';
import SearchFunctionGetListFromCharAndArray from '../../../utilities/SearchFunctionGetListFromCharAndArray';
import { useSearchParams } from 'react-router-dom';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    /* background-color: ${colors.bgColorBlack2}; */
    /* border-radius: 10px;  */
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
`;

const SpaceTitle = styled.div`
    width: 100%;
    /* height: 5%; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${colors.bgColorBlack2};

    & .title {
        font-size: 25px;
        letter-spacing: 2px;
        font-weight: 800;
        text-transform: uppercase;
        margin: 0;
        padding: 0;
        color: white;
    }
`;

const SpaceFilters = styled.div`
    width: 100%;
    /* height: 5%; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;

    & .search-input {
        width: 50%;
        height: 100%;
        border: 1px solid white;
        border-radius: 10px;
        padding: 0 10px;
        margin: 10px 0;
    }

    & .select-year {
        border: 1px solid white;
        border-radius: 10px;
        padding: 1px;
        font-size: 10px;
        text-align: center;
    }
`;

const SpaceListWrestlers = styled.div`
    width: 95%;
    /* height: calc(100% - 15%); */
    display: flex;
    flex-direction: column;
    align-items: center;
    
    padding: 10px;
    row-gap: 5px;
    overflow-y: auto;
`;

const GeneralRenderingSpecificStats = (
    {
        apiFunctionGetStats,
        title,
        yearStart,
        wrestlerDataStart,
        stat
    }
) => {
    let navigate = useNavigate();
    const wrestlersData = wrestlerDataStart;
    const [isLoading, setIsLoading] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const year = yearStart;
    const [selectedYear, setSelectedYear] = useState(year);
    const [allWrestlers, setAllWrestlers] = useState<Record<string, any[]>>({ [year]: wrestlersData });
    const [searchText, setSearchText] = useState('');
    const wrestlers = useMemo(() => {
        const base: any[] = allWrestlers[selectedYear] ?? [];
        if (!searchText) return base;
        return SearchFunctionGetListFromCharAndArray(searchText, base);
    }, [allWrestlers, selectedYear, searchText]);

    // Genera gli anni dal 2005 all'anno corrente + globale
    const currentYear = new Date().getFullYear();
    const years = ['globale', ...Array.from({ length: currentYear - 2004 }, (_, i) => currentYear - i)];

    // Handle navigate to wrestler
    function navigateToWrestler(wrestlerId: string, wrestlerName: string): void {
        navigate(`/wrestlers/i_${wrestlerId}_d_${wrestlerName}`);
    }


    async function handleYearChange(e: React.ChangeEvent<HTMLSelectElement>): Promise<void> {
        const newYear = e.target.value;
        setSelectedYear(newYear);

        if (allWrestlers[newYear]) {
            return;
        }
        setIsLoading(true);
        try {
            const response = await apiFunctionGetStats(1, `${newYear}&is_all=true`);
            setAllWrestlers(prev => ({ ...prev, [newYear]: response.data }));
        } catch (error) {
            console.error('Errore nel caricamento dei dati:', error);
        } finally {
            setIsLoading(false);
        }
    }


    function handleSearchInput(e: React.ChangeEvent<HTMLInputElement>): void {
        setSearchText(e.target.value);
    }

     // se è in loading, mostro il loading state
     if(isLoading) {
        return <LoadingState />;
    }

    return (
        <MainContainer isMobile={true} className={`main-container-mobile-${title}`}>
            <Wrapper className='wrapper'>

                <SpaceTitle className='space-title'>
                    <h1 className='title'>{title}</h1>
                </SpaceTitle>

                <SpaceFilters className='space-filters'>
                    <input type='text' placeholder='Cerca' className='search-input' onChange={handleSearchInput} />
                    <select className='select-year' value={selectedYear} onChange={handleYearChange}>
                        {years.map((year) => (
                            <option key={year} value={year}>
                                {/* Se year uguale a globale, trasformare in All Time */}
                                {year === 'globale' ? 'All Time' : year}
                            </option>
                        ))}
                    </select>
                </SpaceFilters>

                <SpaceListWrestlers className='space-list-wrestlers'>
                    {wrestlers.map((wrestler) => (
                        <SingleCardStatWrestlerMobile
                            key={wrestler.id}
                            wrestlerId={wrestler.id}
                            wrestlerAvatar={wrestler.avatar_path}
                            wrestlerName={wrestler.name}
                            value={wrestler[stat]}
                            position={wrestler.position}
                            onClick={() => navigateToWrestler(wrestler.id, wrestler.name)}
                        />
                    ))}
                </SpaceListWrestlers>
            </Wrapper>
        </MainContainer>
    );
};

export default GeneralRenderingSpecificStats;